import {
  Grid,
  Button,
  Box,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

import { uploadNotificationCertificateZip } from "../../services/NotificationCertificateService";
import CardHeader from "../General/CardHeader";
import GlassCard from "../General/GlassCard";
import FileUploadBox from "../General/FileUploadBox";
import { useToast } from "../../context/ToastContext";

export default function UploadNotificationCertificate() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [stage, setStage] = useState("");
  const [status, setStatus] = useState("");

  const handleFileSelect = (file) => {
    if (file) {
      const validExtensions = ["zip"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        showToast("Solo se permiten archivos comprimidos en formato .zip", "info")
        setSelectedFile(null);
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    setLoading(true);

    if (!stage || !status || !selectedFile) {
      showToast(
        "Debe completar todos los campos y seleccionar un archivo.",
      "info")
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("stage", stage);
    formData.append("result_status", status);

    try {
      const response = await uploadNotificationCertificateZip(formData);

      showToast(response.data.message, "success")
      setSelectedFile(null);
      setStage("");
      setStatus("");
    } catch (error) {
      showToast(
        error.response?.data?.message ||
          "Ocurrió un error inesperado al subir el archivo.",
      "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12 }}>

        <GlassCard>
          <CardHeader
            icon={<AssignmentTurnedInOutlinedIcon />}
            title="Subir Cedulas de Notificación"
            description="Subí un archivo ZIP con cédulas escaneadas. El sistema extraerá los datos automáticamente."
          />
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  label="Etapa de las cédulas"
                  value={stage}
                  onChange={(e) => setStage(e.target.value)}
                  fullWidth
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                >
                  <MenuItem value="stage_1">ETAPA 1</MenuItem>
                  <MenuItem value="stage_2">ETAPA 2</MenuItem>
                  <MenuItem value="stage_3">ETAPA 3</MenuItem>
                  <MenuItem value="stage_4">ETAPA 4</MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  label="Resultado de la notificación"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  fullWidth
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                >
                  <MenuItem value="success">LOGRADO</MenuItem>
                  <MenuItem value="no_success">NO LOGRADO</MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <FileUploadBox
                  selectedFile={selectedFile}
                  onFileSelect={handleFileSelect}
                  accept=".zip"
                  placeholder="Seleccionar archivo ZIP"
                  helperText="O arrastrá y soltá el archivo aquí (.zip)"
                />
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={loading}
                  sx={{
                    borderRadius: 2.5,
                    fontWeight: 900,
                    textTransform: "none",
                    fontSize: 16,
                  }}
                >
                  {loading
                    ? "Procesando en segundo plano..."
                    : "Subir y procesar cédulas"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
